import React, {ReactNode} from 'react';

import {SINGLE_VISION_USAGE_NAME, PRESCRIPTION_METHOD} from 'constants/product';
import {PrescriptionType} from 'desktop/types/checkoutItemsType';

import {BaseInfoRow} from '../baseInfoRowV2/baseInfoRow';

import {
    EmailPrescriptionTooltip,
    OnlinePrescription,
    UploadPrescription,
} from './prescriptionVariations/prescriptionVariations';

type PropsType = {
    prescription: PrescriptionType;
    usageName: ReactNode;
    price: number;
    specialPrice: number;
    description?: ReactNode;
    prismContent?: ReactNode;
};

/**
 * Display prescription for eyeglasses
 * @param {PropsType} props - component props
 * @return {Node} - component for prescription
 */
export const CartItemEyeglassesPrescription = ({
    description,
    prescription,
    price,
    prismContent,
    specialPrice,
    usageName,
}: PropsType) => {
    let prescriptionRender;

    switch (prescription.method) {
        case PRESCRIPTION_METHOD.UPLOAD_METHOD: {
            prescriptionRender = <UploadPrescription link={prescription.link!} />;
            break;
        }
        case PRESCRIPTION_METHOD.MAGNIFICATION_METHOD:
        case PRESCRIPTION_METHOD.FILL_IT_ONLINE_METHOD:
        case PRESCRIPTION_METHOD.BY_SAVED: {
            prescriptionRender = (
                <OnlinePrescription
                    isSingleVision={usageName === SINGLE_VISION_USAGE_NAME}
                    prescription={prescription}
                />
            );
            break;
        }
        case PRESCRIPTION_METHOD.SEND_EMAIL_OR_FAX_METHOD:
            prescriptionRender = <EmailPrescriptionTooltip />;
            break;
        default:
            prescriptionRender = 'Non-prescription';
    }

    return (
        <BaseInfoRow
            dataTestName="useGlassesFor"
            dataTestValue={String(usageName)}
            description={description}
            label="Lens:"
            link={<>({prescriptionRender})</>}
            postfix={prismContent}
            price={price}
            specialPrice={specialPrice}
            title={usageName}
        />
    );
};
